export enum LOCAL_STORAGE_KEYS {
  AUTH_TOKEN = 'brokertool-t',
  USER_NAME = 'brokertool-user',
  LOGIN_TYPE = 'brokertool-lt',
  LOGIN_REDIRECT_URL = 'brokertool-redirect',
  IS_LOGIN_LAST_ACTION = 'brokertool-login-l-a'
}
